<template>
    <div class="top-table-filter-container" v-if="!isManagersOrClient()">
        <!-- Десктопная версия -->
        <div class="green-filter d-none d-md-flex mb-2">
            <span v-for="(item, index) in greenFilterMenu" :key="index" :class="`mr-3 ${item.active ? 'green-link active' : 'green-link'}`" @click="changeActive(index)">
                {{ item.title }}
            </span>
        </div>

        <!-- Цветные квадратики для быстрой фильтрации по статусам -->
        <div class="status-color-filters d-flex align-items-center mb-2">
            <span class="status-color-filters-title">Фильтр по цветам:</span>
            <div 
                v-for="(filter, index) in statusColorFilters"
                :key="index"
                :class="`status-color-square ${filter.class} ${filter.active ? 'active' : ''}`"
                :id="`status-filter-${index}`"
                @click="toggleStatusFilter(index)"
                v-b-tooltip.hover
                :title="getStatusFilterTooltip(filter)"
            ></div>
        </div>

        <!-- Мобильная версия -->
        <div class="d-flex d-md-none mobile-filter-container">
            <!-- Бургер-меню -->
            <button 
                class="burger-menu-btn"
                @click="toggleMobileMenu"
                :class="{ active: isMobileMenuOpen }"
            >
                <span class="burger-line"></span>
                <span class="burger-line"></span>
                <span class="burger-line"></span>
            </button>

            <!-- Выпадающее меню -->
            <div class="mobile-dropdown" :class="{ show: isMobileMenuOpen }">
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Заказы</h6>
                    <div class="mobile-filter-items">
                        <span 
                            v-for="(item, index) in greenFilterMenu"
                            :key="index"
                            :class="`mobile-filter-item ${item.active ? 'active' : ''}`"
                            @click="changeActive(index); closeMobileMenu()"
                        >
                            {{ item.title }}
                        </span>
                    </div>
                </div>

                <!-- Цветные квадратики для быстрой фильтрации по статусам -->
                <div class="mobile-filter-section">
                    <h6 class="mobile-filter-title">Фильтр по статусам</h6>
                    <div class="mobile-status-filters d-flex flex-wrap">
                        <div 
                            v-for="(filter, index) in statusColorFilters"
                            :key="index"
                            :class="`status-color-square ${filter.class} ${filter.active ? 'active' : ''}`"
                            :id="`mobile-status-filter-${index}`"
                            @click="toggleStatusFilter(index); closeMobileMenu()"
                            v-b-tooltip.hover
                            :title="getStatusFilterTooltip(filter)"
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
    export default {
        props: {
            api: {type: String, required: true},              // Link on API for table working
        },
        data() {
            return {
                isMobileMenuOpen: false,
                greenFilterMenu: [
                    {title: "Все заказы", active: true},
                    {title: "Мои заказы", active: false, only_my_orders: true}
                ],
                additionalParameter: '',
                statusColorFilters: [
                    {
                        class: 'table-secondary',
                        statusIds: [359, 360, 539, 540, 541, 542, 543, 544, 545, 557], // Статусы "В работе"
                        active: false,
                        tooltip: 'В работе'
                    },
                    {
                        class: 'table-pre-success',
                        statusIds: [361],
                        active: false,
                        tooltip: ''
                    },
                    {
                        class: 'table-warning',
                        statusIds: [424],
                        active: false,
                        tooltip: ''
                    },
                    {
                        class: 'table-success',
                        statusIds: [421],
                        active: false,
                        tooltip: ''
                    },
                    {
                        class: 'table-danger',
                        statusIds: [362],
                        active: false,
                        tooltip: ''
                    }
                ],
            }
        },
        computed: {
            ...mapGetters('auth', ['currentUser'])
        },
        mounted() {
            const savedIndex = this.$store.state.userLocalSettings.filterSettings.orderServiceTable;
            // Если сохраненного индекса нет, используем 0 (первый элемент - "Все заказы")
            this.changeActive(savedIndex !== undefined && savedIndex !== null ? savedIndex : 0);
        },
        methods: {
            changeActive(activeIndex) {
                let additionalParameter = ''
                this.$store.dispatch("userLocalSettings/SET_FILTER_SETTINGS", {
                    name: 'orderServiceTable',
                    value: activeIndex
                });
                this.greenFilterMenu.forEach((item, index) => {
                    item.active = false
                    if (activeIndex == index) {
                        item.active = true
                        if (item.only_my_orders) {
                            additionalParameter = '&only_my_orders=' + item.only_my_orders
                        }
                    }
                })
                
                // Сохраняем базовый параметр и применяем статусный фильтр
                this.additionalParameter = additionalParameter;
                this.applyStatusFilter();
            },
            isManagersOrClient() {
                if (this.currentUser.role.includes("logistics-manager") ||
                    this.currentUser.role.includes("TO-manager") ||
                    this.currentUser.role.includes("logistics-multim-manager") ||
                    this.currentUser.role.includes("bsz-manager") ||
                    this.currentUser.role.includes("b2c-manager") ||
                    this.currentUser.role.includes("client")) {

                    return true
                }
                return false
            },

            // Методы для мобильного меню
            toggleMobileMenu() {
                this.isMobileMenuOpen = !this.isMobileMenuOpen;
            },

            closeMobileMenu() {
                this.isMobileMenuOpen = false;
            },
            toggleStatusFilter(index) {
                const filter = this.statusColorFilters[index];
                
                // Переключаем состояние фильтра (можно выбирать несколько)
                filter.active = !filter.active;
                
                this.applyStatusFilter();
            },
            applyStatusFilter() {
                // Находим все активные фильтры
                const activeFilters = this.statusColorFilters.filter(f => f.active);
                
                let additionalParameter = this.additionalParameter;
                
                // Удаляем предыдущий фильтр по статусам из параметров
                // Находим и удаляем reference_order_status_id из строки
                additionalParameter = additionalParameter.replace(/&reference_order_status_id=[^&]*/g, '');
                
                // Объединяем статусы из всех активных фильтров
                if (activeFilters.length > 0) {
                    const allStatusIds = new Set();
                    
                    activeFilters.forEach(filter => {
                        if (filter.statusIds && filter.statusIds.length > 0) {
                            filter.statusIds.forEach(id => allStatusIds.add(id));
                        }
                    });
                    
                    // Если есть статусы, добавляем их в параметры
                    if (allStatusIds.size > 0) {
                        additionalParameter += `&reference_order_status_id=${Array.from(allStatusIds).join(',')}`;
                    }
                }
                
                this.$emit('setFilteringApiParameter', additionalParameter);
            },
            getStatusFilterTooltip(filter) {
                // Получаем названия статусов из store
                const statusProperties = this.$store.getters.GROUPED_REFERENCE_PROPERTIES;
                
                // Проверяем, что данные загружены
                if (!statusProperties || !statusProperties[35]) {
                    // Если данные еще не загружены, возвращаем базовую информацию
                    if (filter.statusIds.length > 0) {
                        return `Статусы: ${filter.statusIds.join(', ')}`;
                    }
                    return 'Все остальные статусы';
                }
                
                const orderStatuses = statusProperties[35];
                
                if (filter.statusIds.length > 0) {
                    const statusNames = filter.statusIds.map(id => {
                        // Структура данных: orderStatuses[status].id и orderStatuses[status].name
                        // Ищем статус по id в объекте
                        let status = null;
                        if (typeof orderStatuses === 'object') {
                            // Проходим по всем ключам объекта и ищем по id
                            for (let key in orderStatuses) {
                                if (orderStatuses[key] && orderStatuses[key].id === id) {
                                    status = orderStatuses[key];
                                    break;
                                }
                            }
                        }
                        return status ? status.name : `Статус ${id}`;
                    });
                    
                    // Формируем информативную подсказку
                    const colorName = this.getColorName(filter.class);
                    return `${colorName}: ${statusNames.join(', ')}`;
                } else {
                    // Для серого квадратика (все остальные статусы)
                    return 'Все остальные статусы';
                }
            },
            getColorName(className) {
                const colorMap = {
                    'table-success': 'Зеленый',
                    'table-danger': 'Красный',
                    'table-warning': 'Желтый',
                    'table-pre-success': 'Светло-зеленый',
                    'table-secondary': 'Серый'
                };
                return colorMap[className] || 'Неизвестный';
            }
        }
    }
</script>

<style scoped>
.status-color-filters-title {
    font-size: 12px;
    color: #5a6268;
    margin-right: 0;
    font-weight: normal;
}
/* Стили для цветных квадратиков фильтрации по статусам */
.status-color-filters {
    gap: 8px;
    position: absolute;
    bottom: -34px;
    left: 0;
    z-index: 9;
    width: 250px;
}

.status-color-square {
    width: 18px;
    height: 18px;
    border-radius: 4px;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.2s ease;
    position: relative;
    opacity: 0.4; /* По умолчанию бледные */
}

.status-color-square:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    opacity: 0.7; /* При наведении немного ярче */
}

.status-color-square.active {
    border-color: #333;
    box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.1);
    opacity: 1; /* Активные - полностью яркие */
}

.status-color-square.table-success {
    background-color: #28a745;
}

.status-color-square.table-danger {
    background-color: #dc3545;
}

.status-color-square.table-warning {
    background-color: #ffc107;
}

.status-color-square.table-pre-success {
    background-color: #90ee90;
}

.status-color-square.table-secondary {
    background-color: #6c757d;
}

/* Мобильная версия */
.mobile-status-filters {
    gap: 12px;
    padding: 8px 0;
}

.mobile-status-filters .status-color-square {
    width: 32px;
    height: 32px;
}
</style>
